var map = {
	"./de/btn-view.png": "+gGL",
	"./en/btn-view.png": "zSMk",
	"./es/btn-view.png": "/9gt",
	"./fr/btn-view.png": "ZFz2",
	"./ja/btn-view.png": "W0F6",
	"./ko/btn-view.png": "kGw/",
	"./pt/btn-view.png": "kBy8",
	"./ru/btn-view.png": "t4Kk",
	"./tc/btn-view.png": "DEhy",
	"./th/btn-view.png": "NLJq"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iDM7";